import React from 'react'
import { Box, Container, Typography } from '@mui/material';
import Colors from '../colors';

function EncourageCreation({ headerText, suggestionText, borderColor=Colors.green }) {

    const styles = {
        containerStyles: {
            display: 'flex',
            flexDirection: 'column',
            alignContent: 'center',
            justifyContent: 'center',
            boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.2)',
            border: `1px solid ${borderColor}`,
            borderRadius: '10px',
            padding: '10px',
        },
        textContainer: {

        },
        text: {
            fontFamily: 'Jost',
            textAlign: 'center',
            fontWeight: '600',
        }
    };

    return (
        <Container sx={styles.containerStyles} >
            <Box sx={styles.textContainer} >
                <Typography sx={{...styles.text, fontSize: '1.15rem'}} >
                    {headerText}
                </Typography>
            </Box>
            <Box sx={styles.textContainer} >
                <Typography sx={{...styles.text, color: Colors.gray}} >
                    {suggestionText}
                </Typography>
            </Box>
        </Container>
    )
}

export default EncourageCreation;